module.exports = "#define GLSLIFY 1\nuniform vec3 glowColor;\nuniform float uFadeTime;\nvarying float intensity;\nvarying float alpha;\n\nvoid main()\n{\n\n float distanceToCenter = distance(gl_PointCoord, vec2(0.5));\n        float pct = 1.0 - smoothstep(0.0, 0.5, distanceToCenter);\n        vec3 color = vec3(1.0) * gl_FragColor.rgb;\n\n        vec3 glow = glowColor * intensity;\n\n        gl_FragColor = vec4(glow, clamp(alpha, 0.0, uFadeTime));\n\n        gl_FragColor = vec4(glow, pct * gl_FragColor.a);\n\n\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/shaders/flashing.frag
// module id = 736u
// module chunks = 1